module.exports = __webpack_public_path__ + "img/SelectFromMenu.c972f08e.gif";